<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
          <b-overlay :show='loader'>
            <iq-card>
                <template v-slot:body>
                    <b-row>
                      <b-col>
                        <list-report-head :base-url="awarenessEventServiceBaseUrl" uri="/configuration/report-heading/detail" :org-id="3">
                          {{ $t('info_manage.patient_details') }}
                        </list-report-head>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="8" sm="12">
                          <div>
                              <table class="table table-sm table-striped table-hover">
                                  <tbody>
                                      <b-tr v-if="detailData.application_id">
                                          <b-th style="width:30%">{{$t('info_manage.patient_id')}}</b-th>
                                          <b-th style="width:5%">:</b-th>
                                          <b-th>{{ $n(detailData.application_id, { useGrouping: false }) }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th>{{$t('globalTrans.name')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ $i18n.locale=='bn' ? detailData.name_bn : capitalizeWords(detailData.name) }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th>{{$t('globalTrans.father_name')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ $i18n.locale=='bn' ? detailData.father_name_bn : capitalizeWords(detailData.father_name) }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th>{{$t('globalTrans.mother_name')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ $i18n.locale=='bn' ? detailData.mother_name_bn : capitalizeWords(detailData.mother_name) }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th>{{$t('externalUser.mobile_no')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ $i18n.locale=='bn' ? '০' : '0' }}{{ $n(detailData.mobile, { useGrouping: false }) }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th>{{$t('externalUser.disability_types')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ getDisabilityTypeNameList(detailData.disability_types) }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th>{{$t('globalTrans.gender')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ $i18n.locale=='bn' ? detailData.gender_bn : detailData.gender }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.marital_status === 1">
                                          <b-th>{{$t('info_manage.spouse_name')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ detailData.spouse_name !== null ? ($i18n.locale=='bn' ? detailData.spouse_name_bn : capitalizeWords(detailData.spouse_name)) : '' }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                        <b-th style="width:30%">{{$t('consultancy_therapy_center.center_name')}}</b-th>
                                        <b-th style="width:5%">:</b-th>
                                        <b-th>{{ lang === 'bn' ? detailData.center_name_bn : capitalizeWords(detailData.center_name) }}</b-th>
                                      </b-tr>
                                  </tbody>
                              </table>
                          </div>
                      </b-col>
                      <b-col lg="4" sm="12">
                        <div class="d-flex align-items-center text-center" style="height:350px; margin: 15%;margin-top: 0;" v-if="detailData.photo">
                          <b-img class="mb-2" style="border-2px solid;width:200px; max-height:200px; margin-left: 10px; border: solid; height: 300px, width: 300px;" fluid :src="awarenessEventServiceBaseUrl + 'storage' + detailData.photo"  alt="Patient's Photo"></b-img>
                        </div>
                      </b-col>
                      <b-col lg="6" sm="12">
                          <div>
                              <table class="table table-sm table-striped table-hover">
                                  <tbody>
                                      <b-tr>
                                          <b-th>{{$t('event_manage.year')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ $n(detailData.registration_year, { useGrouping: false }) }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                        <b-th style="width:30%">{{$t('event_manage.registration_date')}}</b-th>
                                        <b-th style="width:5%">:</b-th>
                                        <b-th>{{ detailData.registration_date | dateFormat }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                        <b-th>{{$t('externalUser.birth_id')}}</b-th>
                                        <b-th>:</b-th>
                                        <b-th>{{ detailData.birth_id ? $n(detailData.birth_id, { useGrouping: false }) : '' }}</b-th>
                                      </b-tr>
                                        <b-tr>
                                        <b-th>{{$t('globalTrans.date_of_birth')}}</b-th>
                                        <b-th>:</b-th>
                                        <b-th>{{ detailData.birth_date | dateFormat }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th>{{$t('event_manage.nid_no')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ detailData.nid ? $n(detailData.nid, { useGrouping: false }) : '' }}</b-th>
                                      </b-tr>
                                  </tbody>
                              </table>
                          </div>
                      </b-col>
                      <b-col lg="6" sm="12">
                          <div>
                              <table class="table table-sm table-striped table-hover">
                                  <tbody>
                                    <b-tr>
                                          <b-th>{{$t('externalUser.center')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ $i18n.locale=='bn' ? detailData.center_name_bn : capitalizeWords(detailData.center_name) }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th style="width:30%">{{$t('externalUser.dss_id')}}</b-th>
                                          <b-th style="width:5%">:</b-th>
                                          <b-th>{{ $n(detailData.dss_id, { useGrouping: false }) }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th>{{$t('externalUser.marital_status')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ $i18n.locale=='bn' ? detailData.mat_status_bn : detailData.mat_status }}</b-th>
                                      </b-tr>
                                          <b-tr>
                                          <b-th>{{$t('event_manage.month')}}</b-th>
                                          <b-th>:</b-th>
                                            <b-th>{{ $i18n.locale == 'bn' ? detailData.month_bn : detailData.month }}</b-th>
                                      </b-tr>
                                      <b-tr>
                                          <b-th>{{$t('globalTrans.status')}}</b-th>
                                          <b-th>:</b-th>
                                          <b-th>{{ getStatus(detailData.status) }}</b-th>
                                      </b-tr>
                                  </tbody>
                              </table>
                          </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="6" sm="6" class="text-center mb-4">
                        <h5 class='complain-title' style="font-weight: bold">{{ $t('info_manage.present_address') }}</h5>
                      </b-col>
                      <b-col lg="6" sm="6" class="text-center mb-4">
                        <h5 class='complain-title' style="font-weight: bold">{{ $t('info_manage.permanent_address') }}</h5>
                      </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6" sm="6">
                            <div>
                                <table class="table table-sm table-striped table-hover">
                                  <tbody>
                                      <b-tr v-if="detailData.pr_division_id">
                                          <b-th style="" scope="row">{{ $t('org_pro_division.division') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="" class="">{{ ($i18n.locale=='bn') ? detailData.division_name_bn : detailData.division_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pr_district_id">
                                          <b-th style="" scope="row">{{ $t('org_pro_district.district') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.district_name_bn : detailData.district_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pr_upazila_id">
                                          <b-th style="" scope="row">{{ $t('org_pro_upazilla.upazilla')}} </b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.upazilla_name_bn : detailData.upazilla_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pr_union_id">
                                          <b-th style="" scope="row">{{ $t('org_pro_union.union') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.union_name_bn : detailData.union_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pr_city_corporation_id">
                                          <b-th style="" scope="row">{{ $t('org_pro.city_corporation') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.cityCor_name_bn : detailData.cityCor_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pr_ward_id">
                                          <b-th style="" scope="row">{{ $t('org_pro.ward') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.ward_name_bn : detailData.ward_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pr_paurasabha_id">
                                          <b-th style="" scope="row">{{ $t('org_pro.pauroshoba') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.pauroshoba_name_bn : detailData.pauroshoba_name }}</b-th>
                                      </b-tr>
                                  </tbody>
                                </table>
                            </div>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <div>
                                <table class="table table-sm table-striped table-hover">
                                  <tbody>
                                      <b-tr v-if="detailData.pm_division_id">
                                          <b-th style="" class="" scope="row">{{ $t('org_pro_division.division') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="" class="">{{ ($i18n.locale=='bn') ? detailData.division_name_bn : detailData.division_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pm_district_id">
                                          <b-th style="" scope="row">{{ $t('org_pro_district.district') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.district_name_bn : detailData.district_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pm_upazilla_id">
                                          <b-th style="" scope="row">{{ $t('org_pro_upazilla.upazilla')}} </b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.upazilla_name_bn : detailData.upazilla_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pm_union_id">
                                          <b-th style="" scope="row">{{ $t('org_pro_union.union') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.union_name_bn : detailData.union_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pm_city_corporation_id">
                                          <b-th style="" scope="row">{{ $t('org_pro.city_corporation') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.pm_cityCor_name_bn : detailData.pm_cityCor_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pm_ward_id">
                                          <b-th style="" scope="row">{{ $t('org_pro.ward') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.ward_name_bn : detailData.ward_name }}</b-th>
                                      </b-tr>
                                      <b-tr v-if="detailData.pm_paurasabha_id">
                                          <b-th style="" scope="row">{{ $t('org_pro.pauroshoba') }}</b-th>
                                          <b-th>:</b-th>
                                          <b-th style="">{{ ($i18n.locale=='bn') ? detailData.pauroshoba_name_bn : detailData.pauroshoba_name }}</b-th>
                                      </b-tr>
                                  </tbody>
                                </table>
                            </div>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
          </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { awarenessEventServiceBaseUrl } from '@/config/api_config'
import ListReportHead from '@/components/custom/ListReportHeadAwareness.vue'
import ExportPdf from './export-pdf_details'

export default {
  props: ['item'],
  components: {
    ListReportHead
  },
  created () {
    if (this.item) {
      this.detailData = this.getRelationalData(this.item)
    }
  },
  mounted () {
    core.index()
  },
  data () {
     return {
      loader: false,
      detailData: '',
      getAreaType: [
          { value: 1, text_en: 'City Corpoation', text_bn: 'সিটি কর্পোরেশন' },
          { value: 2, text_en: 'Pauroshoba', text_bn: 'পৌরশোবা' },
          { value: 3, text_en: 'Union', text_bn: 'ইউনিয়ন' }
      ],
      awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl
    }
  },
  computed: {
    lang () {
      return this.$i18n.locale
    },
     currentLocale () {
      return this.$i18n.locale
    },
    monthList: function () {
      return this.$store.state.commonObj.monthList
    },
    wardList () {
      return this.$store.state.commonObj.wardList
    },
    disabilityTypeList () {
      return this.$store.state.AwarenessEventService.commonObj.disabilityTypeList
    },
    maritalStatus: function () {
      return this.$store.state.commonObj.maritalStatus
    },
    genderList: function () {
      return this.$store.state.commonObj.genderList
    },
    centerList: function () {
      return this.$store.state.commonObj.officeList.filter(item => item.org_id === 3)
    },
    serviceTypeList () {
      return this.$store.state.AwarenessEventService.commonObj.serviceTypeList
    }
  },
  watch: {
  },
  methods: {
    getCropNameList (croptypeID) {
      const cropNameList = this.$store.state.SeedsFertilizer.commonObj.CropNameList.filter(item => item.status === 1)
      if (croptypeID) {
        return cropNameList.filter(cropName => cropName.crop_type_id === croptypeID)
      }
      return cropNameList
    },
    capitalizeWords (string) {
        return string?.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })
    },
    getRelationalData (data) {
      this.loader = true
      if (data.photo === null) {
        data.photo = '/uploads/patient/photo/default.png'
      }
      const areaList = this.getAreaType.find(aType => aType.value === parseInt(data.pr_area_type_id))
      const divList = this.$store.state.commonObj.divisionList.find(div => div.value === data.pr_division_id)
      const disList = this.$store.state.commonObj.districtList.find(dis => dis.value === data.pr_district_id)
      const upaList = this.$store.state.commonObj.upazilaList.find(upa => upa.value === data.pr_upazila_id)
      const unionList = this.$store.state.commonObj.unionList.find(union => union.value === data.pr_union_id)
      const cityCorList = this.$store.state.commonObj.cityCorporationList.find(city => city.value === data.pr_city_corporation_id)
      const pauroList = this.$store.state.commonObj.pauroshobaList.find(pauro => pauro.value === data.pr_paurasabha_id)
      const wardList = this.$store.state.commonObj.wardList.find(ward => ward.value === data.pr_ward_id)
      const areaListPm = this.getAreaType.find(aType => aType.value === parseInt(data.pm_area_type_id))
      const divListPm = this.$store.state.commonObj.divisionList.find(div => div.value === data.pm_division_id)
      const disListPm = this.$store.state.commonObj.districtList.find(dis => dis.value === data.pm_district_id)
      const upaListPm = this.$store.state.commonObj.upazilaList.find(upa => upa.value === data.pm_upazila_id)
      const unionListPm = this.$store.state.commonObj.unionList.find(union => union.value === data.pm_union_id)
      const cityCorListPm = this.$store.state.commonObj.cityCorporationList.find(city => city.value === data.pm_city_corporation_id)
      const pauroListPm = this.$store.state.commonObj.pauroshobaList.find(pauro => pauro.value === data.pm_paurasabha_id)
      const wardListPm = this.$store.state.commonObj.wardList.find(ward => ward.value === data.pm_ward_id)
      const serviceObj = this.$store.state.AwarenessEventService.commonObj.serviceTypeList.find(serviceType => serviceType.value === data.service_type_id)
      const materialStatusObj = this.$store.state.commonObj.maritalStatus.find(matStatus => matStatus.value === data.marital_status)
      const genderObj = this.$store.state.commonObj.genderList.find(gender => gender.value === data.gender)
      const monthObj = this.$store.state.commonObj.monthList.find(month => month.value === data.registration_month)
      const centerObj = this.$store.state.AwarenessEventService.commonObj.idscCenterList.find(center => center.value === data.center_id)
      this.loader = false
      return Object.assign({}, data,
        {
          area_name: areaList !== undefined ? areaList.text_en : '',
          area_name_bn: areaList !== undefined ? areaList.text_bn : ''
        },
        {
          div_name: divList !== undefined ? divList.text_en : '',
          div_name_bn: divList !== undefined ? divList.text_bn : ''
        },
        {
          dis_name: disList !== undefined ? disList.text_en : '',
          dis_name_bn: disList !== undefined ? disList.text_bn : ''
        },
        {
          upa_name: upaList !== undefined ? upaList.text_en : '',
          upa_name_bn: upaList !== undefined ? upaList.text_bn : ''
        },
        {
          union_name: unionList !== undefined ? unionList.text_en : '',
          union_name_bn: unionList !== undefined ? unionList.text_bn : ''
        },
        {
          cityCor_name: cityCorList !== undefined ? cityCorList.text_en : '',
          cityCor_name_bn: cityCorList !== undefined ? cityCorList.text_bn : ''
        },
        {
          pauro_name: pauroList !== undefined ? pauroList.text_en : '',
          pauro_name_bn: pauroList !== undefined ? pauroList.text_bn : ''
        },
        {
          ward_name: wardList !== undefined ? wardList.text_en : '',
          ward_name_bn: wardList !== undefined ? wardList.text_bn : ''
        },
        {
          pm_area_name: areaListPm !== undefined ? areaListPm.text_en : '',
          pm_area_name_bn: areaListPm !== undefined ? areaListPm.text_bn : ''
        },
        {
          pm_div_name: divListPm !== undefined ? divListPm.text_en : '',
          pm_div_name_bn: divListPm !== undefined ? divListPm.text_bn : ''
        },
        {
          pm_dis_name: disListPm !== undefined ? disListPm.text_en : '',
          pm_dis_name_bn: disListPm !== undefined ? disListPm.text_bn : ''
        },
        {
          pm_upa_name: upaListPm !== undefined ? upaListPm.text_en : '',
          pm_upa_name_bn: upaListPm !== undefined ? upaListPm.text_bn : ''
        },
        {
          pm_union_name: unionListPm !== undefined ? unionListPm.text_en : '',
          pm_union_name_bn: unionListPm !== undefined ? unionListPm.text_bn : ''
        },
        {
          pm_cityCor_name: cityCorListPm !== undefined ? cityCorListPm.text_en : '',
          pm_cityCor_name_bn: cityCorListPm !== undefined ? cityCorListPm.text_bn : ''
        },
        {
          pm_pauro_name: pauroListPm !== undefined ? pauroListPm.text_en : '',
          pm_pauro_name_bn: pauroListPm !== undefined ? pauroListPm.text_bn : ''
        },
        {
          pm_ward_name: wardListPm !== undefined ? wardListPm.text_en : '',
          pm_ward_name_bn: wardListPm !== undefined ? wardListPm.text_bn : ''
        },
        {
          service_name: serviceObj !== undefined ? serviceObj.text_en : '',
          service_name_bn: serviceObj !== undefined ? serviceObj.text_bn : ''
        },
        {
          mat_status: materialStatusObj !== undefined ? materialStatusObj.text_en : '',
          mat_status_bn: materialStatusObj !== undefined ? materialStatusObj.text_bn : ''
        },
        {
          gender: genderObj !== undefined ? genderObj.text_en : '',
          gender_bn: genderObj !== undefined ? genderObj.text_bn : ''
        },
        {
          month: monthObj !== undefined ? monthObj.text_en : '',
          month_bn: monthObj !== undefined ? monthObj.text_bn : ''
        },
        {
          center_name: centerObj !== undefined ? centerObj.text_en : '',
          center_name_bn: centerObj !== undefined ? centerObj.text_bn : ''
        }
      )
    },
    getDisabilityTypeNameList (disabilityTypes) {
      const arr = []
      disabilityTypes.forEach(item => {
        const disabilityType = this.disabilityTypeList.find(obj => obj.value === item)
        const disabilityTypeName = this.currentLocale === 'en' ? this.capitalizeWords(disabilityType?.text_en) : disabilityType.text_bn
        arr.push(disabilityTypeName)
      })
      return arr.toString()
    },
    getStatus (status) {
      if (status === 1) {
        return this.$t('event_manage.pending')
      } else if (status === 2) {
        return this.$t('event_manage.forward')
      } else if (status === 3) {
        return this.$t('event_manage.approved')
      } else if (status === 4) {
        return this.$t('event_manage.reject')
      }
    },
    pdfExport () {
      const reportTitle = this.$t('info_manage.patient_details')
      ExportPdf.exportPdfDetails(reportTitle, this.detailData, this, this.awarenessEventServiceBaseUrl, awarenessEventServiceBaseUrl, '/configuration/report-heading/detail', 3)
    }
  }
}
</script>
